import {FC, useEffect} from "react";
import {useAppDispatch} from "../../hooks/redux";
import {useBoardSocket} from "../../features/board/model/useBoardSocket";
import {fetchBoard} from "../../features/board/model/actions";
import {useChatSocket} from "../../features/chat/model/useChatSocket";
import {fetchUnread} from "../../features/chat/model/actions";
import {useEmojiSocket} from "../../features/emoji/model/useEmoji";
import {useTabTitle} from "../../features/notify/model/useTabTitle";
import {useOpenChannel} from "../../features/notify/model/useOpenChannel";
import {usePermissions} from "../../hooks/usePermissions";

/**
 * Живые события на всех страницах (S4.1): доска, чат, командные эмодзи,
 * заголовок вкладки `({N}) ATOM EoL` и уведомления о сообщениях. Рендерится
 * один раз в авторизованной ветке App; на доске подписки не дублируются.
 * Оповещения `notification` (алерты) — по-прежнему `useNotifications`.
 * Уведомления доски — по способности `notifications` (ROLES.md § 4; у «только доска» есть с S12).
 */
const AppRealtime: FC = () => {
    const dispatch = useAppDispatch();
    const openChannel = useOpenChannel();

    useBoardSocket(openChannel, usePermissions().notifications);
    useChatSocket(openChannel);
    useEmojiSocket();
    useTabTitle();

    // Доска — правилу «я взял машину» и хвосту VIN в заголовке уведомления.
    // Всегда свежая: компонент монтируется один раз за вход, а после выхода и
    // нового входа в той же вкладке в сторе остаётся доска прошлой сессии.
    useEffect(() => {
        dispatch(fetchBoard());
        dispatch(fetchUnread());
    }, [dispatch]);

    return null;
};

export default AppRealtime;
